export default __webpack_public_path__ + "5057082.png";